import { z } from 'zod';

/** 仕様設定タブで設定対象を切り替えるサブヘッダーの値。 */
export const ATTENDANCE_CORE_CONFIG_KINDS = ['operationEvents', 'operationPackages'] as const;
export type AttendanceCoreConfigKind = (typeof ATTENDANCE_CORE_CONFIG_KINDS)[number];
export const SearchSchema = z.object({
  kind: z.enum(ATTENDANCE_CORE_CONFIG_KINDS).default('operationEvents')
});